import type { IconDefinition } from '../index.tsx';

export const iconAlert2: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconAlert2',
  icon: [
    16,
    16,
    [],
    '',
    'M16 15H0V12L7 0H9L16 12V15ZM7 4H9V9H7V4ZM7 11H9V13H7V11Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
